<template>
<m-pageframe
    :title="title"
>
<v-container>

    <m-beta-alert
        v-if="beta_code"
        :code="beta_code"
    />

    <v-list-item
        v-for="(item, index) in pages"
        :key="index"
        v-on:click="onClickPage(item)"
    >
        <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon><v-icon>mdi-arrow-right</v-icon></v-list-item-icon>
    </v-list-item>

</v-container>

    <m-integration-features-dialog
        ref="features-dialog"
    />

</m-pageframe>
</template>

<script>
export default {

    mounted () {
        
        if ( this.pages.length == 1 )
        {
            this.onClickPage(this.pages[0]);
        }
    },

    methods: {
        onClickPage(page) {

            if ( page.page == 'features-dialog' )
            {
                this.$refs['features-dialog'].showDialog(this.$route.params.content_type);
                return;
            }

            this.$router.push({
                'name': page.page,
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'content-type': this.$route.params.content_type,
                },
                'query': page.query
            });
        }
    },

    computed: {
        title() {
            let value = this.$route.params.content_type;

            return this.$rc.pretty(value, 'enum_integration_name');
        },

        beta_code() {
            const beta_codes = {
                'vinoshipper': 'beta-integration-vinoshipper',
                'corksy': 'beta-integration-corksy',
            };

            const code = beta_codes[this.$route.params.content_type];
            if ( !code )
                return null;

            if ( !this.$rc.isValidEnumValue(code, 'beta_features') )
                return null;

            return code;
        },

        pages() {
            let ret = [];

            let supports = this.$rc.enumObject('integration_name',this.$route.params.content_type).supports;

            if ( this.$route.params.content_type == 'wine-direct-fulfillment' )
            {
                ret.push(
                    {
                        'title': 'WineDirect Fulfillment Events',
                        'icon': 'mdi-truck',
                        'page': 'events',
                        'query': {
                            'event-contains': 'wine-direct-fulfillment'
                        },
                    }
                );

                ret.push(
                    {
                        'title': 'Automated Message Settings',
                        'icon': 'mdi-robot',
                        'page': 'auto-messages-settings',
                    }
                );
            }

            ret.push(
                    {
                        'title': 'Features',
                        'icon': 'mdi-format-list-bulleted',
                        'page': 'features-dialog'
                    }
                );

            if ( supports.includes('customer') )
            {
                ret.push(
                    {
                        'title': 'Contacts',
                        'icon': 'mdi-account',
                        'page': 'crm-customers'
                    }
                );
            }

            if ( supports.includes('order') )
            {
                ret.push(
                    {
                        'title': 'Orders',
                        'icon': 'mdi-cart',
                        'page': 'crm-orders'
                    }
                );

                ret.push(
                    {
                        'title': 'Orders history (by phone number)',
                        'icon': 'mdi-phone',
                        'page': 'crm-orders-by-phone'
                    }
                );
            }
            
            if ( supports.includes('reservation') )
            {
                ret.push(
                    {
                        'title': 'Reservations',
                        'icon': 'mdi-calendar',
                        'page': 'crm-reservations'
                    }
                );
            }

            if ( supports.includes('reservation-locations') )
            {
                ret.push(
                    {
                        'title': 'Reservation Location Time Zone(s)',
                        'icon': 'mdi-calendar',
                        'page': 'crm-reservation-location-time-zones'
                    }
                );
            }

            if ( supports.includes('shipment') )
            {
                ret.push(
                    {
                        'title': 'Shipments',
                        'icon': 'mdi-truck',
                        'page': 'crm-shipments',
                    }
                );

                ret.push(
                    {
                        'title': 'Shipping Events (Second Generation)',
                        'icon': 'mdi-truck',
                        'page': 'events',
                        'query': {
                            'initial-event-types': 'second-generation-shipping-events',
                        },
                    }
                );
            }

            if ( supports.includes('club') )
            {
                ret.push(
                    {
                        'title': 'Clubs',
                        'icon': 'mdi-all-inclusive',
                        'page': 'crm-club-meta-data',
                    }
                );
            }

            if ( supports.includes('tag') )
            {
                ret.push(
                    {
                        'title': 'Tags',
                        'icon': 'mdi-tag-multiple-outline',
                        'page': 'crm-tag-meta-data',
                    }
                );

                ret.push(
                    {
                        'title': 'Tag Change Log',
                        'icon': 'mdi-code-less-than-or-equal',
                        'page': 'crm-tag-change-log',
                    }
                );
            }

            if ( supports.includes('media-asset-creator') )
            {
                ret.push(
                    {
                        'title': 'Media Assets',
                        'icon': 'mdi-image-multiple-outline',
                        'page': 'media-asset-edit-all-one-content-type',
                    }
                );
            }

           

            

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>